import React from 'react';
import { connect, useSelector } from "react-redux";
import ParticipateButton from "@/components/Buttons/ParticipateButton";
import { Grid, List, ListItem } from '@mui/material'
import AuctionCard from "@/components/ui/AuctionCard";
import AuctionDetailCardDocumentSelector from "@/components/Cards/AuctionDetailCardDocumentSelector";
import { AuctionTypeEnum } from '@/lib/utils/AuctionTypeEnum';
import { AuctionLotStatusEnum } from '../../lib/utils/AuctionLotStatusEnum';
import { handleClearFilterObject, handleClearLotTypeView } from '../../pages/Lots/store/Lots';
import { insertUrlParam } from '../../lib/utils/General';
import useHistory from '../../lib/hooks/useHistory';
import { getNewDateWithOffset } from 'prembid-shared-library-npm/helpers';
import { RootState } from '../../store/Store';
import { GeneralPopper } from '../composite/popper/GeneralPopper';

interface Props {
    imgSrc: string,
    header: string,
    description?: string,
    auctionId: string,
    defaultCommission: string,

    startDateTimeAt?: any,
    endDateTimeAt?: any,
    auctionEndDateTimeAt?: any,

    auctionType: string,

    infoBadgeText?: string,
    dangerBadgeText?: string,

    hasExtensions: boolean,

    settings: any,
    onRefresh: () => void
    documentCount: number,
    handleClearLotTypeView_d: (viewType: any, onCompletedCallback: () => void) => void,
    handleClearFilterObject_d: (onCompletedCallback?: () => void) => void,
}

const AuctionDetailCard: React.FC<Props> = props => {
    const history = useHistory();

    const {
        imgSrc,
        header,
        description,
        auctionId,
        defaultCommission,

        startDateTimeAt,
        endDateTimeAt,
        auctionEndDateTimeAt,

        auctionType,

        infoBadgeText,
        dangerBadgeText,

        hasExtensions,

        settings,
        onRefresh,
        documentCount,
        handleClearLotTypeView_d,
        handleClearFilterObject_d
    } = props;

    const currentDateTimeOffset = useSelector((state: RootState) => state.settings.serverDateTimeDifference);

    const [anchorEl, setAnchorEl] = React.useState(null);

    const now = getNewDateWithOffset(currentDateTimeOffset);
    const start = new Date(startDateTimeAt);
    const end = new Date(endDateTimeAt);




    const recordScrollPosition = () => {
        var top = window.scrollY
        insertUrlParam("top", top.toString())
    }

    const btnViewLotsRoute = () => {
        handleClearLotTypeView_d(settings.DefaultLotView, () => {
            handleClearFilterObject_d(function () {
                recordScrollPosition();
                history.push('/Lots/' + auctionId)
            })
        })
    }

    const btnCatalogueRoute = () => {
        const win: any = window.open('/Catalog/' + auctionId, "_blank");
        win.focus();
    }

    const handleInfoPopperClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleInfoPopperClose = () => {
        setAnchorEl(null);
    };

    const getInfoElement = () => {
        const placeholderText = Number(auctionType) === Number(AuctionTypeEnum.Tender) ? "tender" : "bid";
        const placeholderActioningText = Number(auctionType) === Number(AuctionTypeEnum.Tender) ? "tendering" : "bidding";

        let auctionStatus = AuctionLotStatusEnum.Awaiting;

        if (now < start) auctionStatus = AuctionLotStatusEnum.Awaiting;

        if (now > end) auctionStatus = AuctionLotStatusEnum.Completed;

        if (start < now && now < end) {
            if (hasExtensions) {
                auctionStatus = AuctionLotStatusEnum.Extended;
            } else {
                auctionStatus = AuctionLotStatusEnum.Open;
            }
        }

        return (<List>
            <ListItem>
                <h5 className="text-primary font-weight-bold">{AuctionLotStatusEnum[auctionStatus.toString()]} -{" "}
                    {
                        auctionStatus === AuctionLotStatusEnum.Awaiting &&
                        <span className="text-black font-weight-normal">{"This " + settings.AuctionName.toLowerCase() + " hasn't opened yet, but you need to register if you want to " + placeholderText + " when it does"}</span>
                    }

                    {
                        (auctionStatus === AuctionLotStatusEnum.Open || auctionStatus === AuctionLotStatusEnum.Extended) &&
                        <span className="text-black font-weight-normal">{"This " + settings.AuctionName.toLowerCase() + " is open for you to " + placeholderText + " on " + settings.LotName.toLowerCase() + "s if you have registered and been approved"}</span>
                    }

                    {
                        auctionStatus === AuctionLotStatusEnum.Completed &&
                        <span className="text-black font-weight-normal">{"This " + settings.AuctionName.toLowerCase() + " has completed and " + placeholderActioningText + " is closed"}</span>
                    }
                </h5>
            </ListItem>
            <ListItem>
                <h5 className="text-primary font-weight-bold">{AuctionTypeEnum[auctionType.toString()]} -{" "}
                    {
                        Number(auctionType) === Number(AuctionTypeEnum.Timed) &&
                        <span className="text-black font-weight-normal">{"Start " + placeholderActioningText + " at the opening " + placeholderText + " in increments. The highest " + placeholderText + " is the winner at the end of the " + settings.AuctionName.toLowerCase() + ". Note: This is binding if your " + placeholderText + " is accepted"}</span>
                    }

                    {
                        Number(auctionType) === Number(AuctionTypeEnum.Streamed) &&
                        <span className="text-black font-weight-normal">{"Allowing you to watch a live stream of an onsite " + settings.AuctionName.toLowerCase()}</span>
                    }

                    {
                        Number(auctionType) === Number(AuctionTypeEnum.Tender) &&
                        <span className="text-black font-weight-normal">{"Submit a single confidential Tender. Note: This is binding if your tender is accepted"}</span>
                    }
                </h5>
            </ListItem>
            <ListItem>
                <h5 className="text-primary font-weight-bold">Registration Deposit -{" "}
                    <span className="text-black font-weight-normal">{"The amount held as a deposit to register to " + placeholderText + ". The deposit is "}<span className="text-danger font-weight-bold">FULLY REFUNDABLE </span>{"if you are unsuccessful"}</span>
                </h5>
            </ListItem>
        </List>)
    };



    return (
        <Grid item xs={12} sm={6} lg={4}>
            <AuctionCard
                imgSrc={imgSrc}
                title={header}
                description={description}
                auctionType={auctionType}
                depositAmount={infoBadgeText}
                startDateTimeAt={startDateTimeAt}
                endDateTimeAt={endDateTimeAt}
                auctionEndDateTimeAt={auctionEndDateTimeAt}
                documents={<AuctionDetailCardDocumentSelector auctionId={auctionId} documentCount={documentCount} />}
                onInfoClick={handleInfoPopperClick}
                infoPopper={anchorEl && <GeneralPopper headerText={"Info"} anchorEl={anchorEl} element={getInfoElement()} handleGeneralPopperClose={handleInfoPopperClose} />}
                onOpen={btnViewLotsRoute}
                onCountdownComplete={() => { if (onRefresh) onRefresh(); }}
                actions={
                    <>
                        <div className="pb-row">
                            {now <= end && <div><ParticipateButton part="action" auctionId={auctionId} auctionType={auctionType} /></div>}
                            <div><button type="button" className="pb-btn pb-btn-ink" onClick={btnViewLotsRoute}>{dangerBadgeText}</button></div>
                        </div>
                        {now <= end && <ParticipateButton part="compliance" auctionId={auctionId} auctionType={auctionType} />}
                        <button type="button" className="pb-btn pb-btn-outline" onClick={btnCatalogueRoute}>Catalogue</button>
                    </>
                }
            />
        </Grid>
    )
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        handleClearLotTypeView_d: (viewType: any, onCompletedCallback: () => void) => dispatch(handleClearLotTypeView(viewType, onCompletedCallback)),
        handleClearFilterObject_d: (onCompletedCallback?: () => void) => dispatch(handleClearFilterObject(onCompletedCallback)),
    };
};

const mapStateToProps = (state: any) => ({
    settings: state.settings.settings,
});


export default connect(mapStateToProps, mapDispatchToProps)(AuctionDetailCard);
